import PropTypes from 'prop-types';
import React from 'react';
import Dropzone from 'react-dropzone';
import Promise from 'bluebird';
import utils from '../../../common/utils';
import thumbs from '../../../config/thumbs';
import * as rmd from 'material-ui';
import cx from 'classnames';
import FastImagesPicker from './FastImagesPicker';
import _ from 'lodash';
import config from 'cfg';
import CopyToClipboard from 'react-copy-to-clipboard';
import CopyIcon from 'material-ui/svg-icons/content/content-copy';
import ContentAdd from 'material-ui/svg-icons/content/add';
import NavigationClose from 'material-ui/svg-icons/navigation/close';
import auth from 'dash-front/auth';

class ImageUploaderContainer extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            imageToUpload: null,
            imageToUploadName: '',
            imageToUploadKind: 'other',
            copyToastOpen: false,
            uploadError: false,
            uploadErrorMessage: '',
            imageUploading: false,
            pickedImgKey: null,
            drawerOpen: false,
            userImagesSize: 0,
            userImages: [],
        };
    }
    componentDidMount() {
        this.loadData();
    }
    static contextTypes = {
        user: PropTypes.object.isRequired,
        router: PropTypes.object.isRequired,
    };

    static defaultProps = {
        showGallery: true,
        galleryFirst: false,
    };

    loadData = (additionalState = {}) => {
        const token = auth.getAccessToken();
        return Promise.props({
            userImages: fetch(`${config.dash.api.host}/api/media?access_token=${token}`).then(response =>
                response.json(),
            ),
            userImagesSize: fetch(`${config.dash.api.host}/api/media/size?access_token=${token}`).then(response =>
                response.json(),
            ),
        }).then(response => {
            const { userImages, userImagesSize } = response;
            this.setState({ ...additionalState, userImages, userImagesSize });
        });
    };

    onUpload = () => {
        const { user } = this.context;
        const { _id: userId, client, username } = user;

        this.setState({
            imageUploading: true,
        });

        let { imageToUpload, imageToUploadName, imageToUploadKind } = this.state;
        if (!imageToUploadName) imageToUploadName = imageToUpload.name;

        const formData = new FormData();
        formData.append('file', imageToUpload);
        formData.append('userName', `${client}_${username}`);
        formData.append('imageName', imageToUploadName);
        formData.append('imageKind', imageToUploadKind);

        var additionalState = {
            imageToUpload: null,
            imageToUploadName: '',
            imageToUploadKind: 'other',
            imageUploading: false,
        };

        const token = auth.getAccessToken();
        return fetch(`${config.dash.api.host}/api/media/upload?access_token=${token}`, {
            method: 'POST',
            body: formData,
        })
            .then(response => {
                if (response.status === 200) {
                    return response.json();
                }
            })
            .then(uploadInfo => {
                if (uploadInfo.error) {
                    this.setState({ ...additionalState, uploadError: true, uploadErrorMessage: uploadInfo.message });
                } else {
                    this.setState({ uploadOK: true });
                    this.loadData(additionalState);
                }
            })
            .catch(e => {
                this.setState({
                    ...additionalState,
                    uploadError: true,
                    uploadErrorMessage: 'Could not upload image. Try again.',
                });
            });
    };

    onDelete = (key, keys) => {
        const { user } = this.context;
        const { _id: userId } = user;
        const token = auth.getAccessToken();

        fetch(`${config.dash.api.host}/api/media/delete?access_token=${token}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                keys,
                key,
            }),
        })
            .then(response => {
                console.log(+new Date());
                if (response.status === 200) {
                    return response.json();
                }
            })
            .then(response => {
                this.loadData({ drawerOpen: false, pickedImgKey: null });
            });
    };

    onPick = (value, img) => {
        this.setState({
            drawerOpen: img.key !== this.state.pickedImgKey,
            pickedImgKey: img.key === this.state.pickedImgKey ? null : img.key,
        });
    };

    renderSize = () => {
        return utils.bytesToSize(this.state.userImagesSize, 2);
    };

    onDrop = (acceptedFiles, rejectedFiles) => {
        const image = _.first(acceptedFiles);
        if (image.size > 5 * 1024 * 1024) {
            this.setState({
                imageToUpload: null,
                imageToUploadName: '',
                imageToUploadKind: 'other',
                imageUploading: false,
                uploadError: true,
                uploadErrorMessage: 'Size of the image is more than 5 MB',
            });
        } else {
            this.setState({
                imageToUpload: image,
                imageToUploadName: image.name.replace(`.${utils.getExtension(image.name)}`, ''),
            });
        }
    };

    onImageNameChange = e => {
        this.setState({
            imageToUploadName: e.target.value,
        });
    };

    onImageKindChange = (e, index, value) => {
        this.setState({
            imageToUploadKind: value,
        });
    };

    onImageUploadCancel = () => {
        this.setState({
            imageToUpload: null,
            imageToUploadName: '',
            imageToUploadKind: 'other',
            imageUploaderOpen: false,
        });
    };

    renderImageDetails = () => {
        const img = this.state.userImages.find(i => i.key === this.state.pickedImgKey);
        if (!img) return null;

        const { name, thumbs, url, cdnUrl, s3Url, width, height } = img;
        const previewUrl = thumbs.find(t => t.size === 'preview').s3Url;

        const cdnLabel = this.props.cdnLabel || 'CDN';
        const copyButtons = [{ url: cdnUrl, label: cdnLabel }];

        if (!this.props.cdnOnly) {
            const s3Label = this.props.s3Label || 'S3';
            copyButtons.push({ url: s3Url, label: s3Label });
        }

        return (
            <div className="rlz-image-uploader__image-details" style={{ paddingTop: 70 }}>
                <span className="rlz-image-uploader__image-details__thumb__name">
                    {width} x {height} (original)
                </span>
                <div className="rlz-image-uploader__image-details__preview">
                    <rmd.Paper zDepth={1}>
                        <img src={cdnUrl} alt={name} height={200} style={{ objectFit: 'contain' }} />
                    </rmd.Paper>
                    {this.renderCopyButtons(copyButtons)}
                </div>
                <br />
                <div className="rlz-image-uploader__image-details__thumbs">
                    {thumbs.map(t => {
                        return (
                            <div key={t.key} className="rlz-image-uploader__image-details__thumb">
                                <span className="rlz-image-uploader__image-details__thumb__name">
                                    {t.width} x {t.height}
                                </span>
                                <rmd.Paper zDepth={1}>
                                    <div className="rlz-image-uploader__image-details__thumb__image">
                                        <img
                                            src={t.s3Url || t.cdnUrl || previewUrl}
                                            alt={t.size}
                                            style={{ objectFit: 'contain' }}
                                        />
                                    </div>
                                </rmd.Paper>
                                {this.renderCopyButtons(copyButtons)}
                            </div>
                        );
                    })}
                </div>
                <div className="rlz-image-uploader__image-details__info" />
                <div className="rlz-image-uploader__image-details__actions">
                    <rmd.RaisedButton
                        onClick={() => {
                            const keys = [img.key];
                            img.thumbs.map(t => keys.push(t.key));
                            this.onDelete(img.key, keys);
                        }}
                        label="Delete"
                        secondary
                    />
                </div>
            </div>
        );
    };

    renderCopyButtons = (buttons = []) => {
        return (
            <div className="rlz-image-uploader__copy-buttons">
                {buttons.map(btn => {
                    return (
                        <CopyToClipboard
                            key={btn.url}
                            text={btn.url}
                            onCopy={this.props.onCopy || (value => this.setState({ copyToastOpen: true }))}
                        >
                            <rmd.RaisedButton label={btn.label} />
                        </CopyToClipboard>
                    );
                })}
            </div>
        );
    };

    renderUploadBox = () => {
        const { imageToUpload, imageToUploadName, imageUploading } = this.state;
        const { preview: imagePreview } = imageToUpload || {};

        return (
            <div className="rlz-image-uploader__upload-box">
                <h2>Upload image (drag and drop or add)</h2>
                <div className="rlz-image-uploader__upload">
                    <div className="rlz-image-uploader__image-input">
                        <Dropzone onDrop={this.onDrop}>
                            <div className="rlz-image-uploader__image-preview">
                                <ContentAdd />
                                <img src={imagePreview} />
                            </div>
                        </Dropzone>
                    </div>
                    <div className="rlz-image-uploader__upload-control">
                        <h3>Configure</h3>
                        <rmd.TextField
                            floatingLabelText="Image name (unique) *"
                            value={this.state.imageToUploadName}
                            onChange={this.onImageNameChange}
                        />
                        <br />
                        <rmd.SelectField
                            floatingLabelText="Resource type"
                            value={this.state.imageToUploadKind}
                            onChange={this.onImageKindChange}
                        >
                            {thumbs.map(t => {
                                return <rmd.MenuItem key={t.kind} value={t.kind} primaryText={t.kind} />;
                            })}
                        </rmd.SelectField>
                        <br />
                        <rmd.FlatButton
                            label={imageUploading ? 'Uploading...' : 'Upload'}
                            primary
                            disabled={!imageToUploadName || imageUploading}
                            onTouchTap={this.onUpload}
                        />
                        <rmd.FlatButton
                            label="Cancel"
                            primary
                            disabled={imageUploading || !imageToUpload}
                            onTouchTap={this.onImageUploadCancel}
                        />
                    </div>
                </div>
            </div>
        );
    };

    renderGallery = () => {
        const images = _.sortBy(this.state.userImages, img => {
            return -new Date(img.createdAt);
        });
        return (
            <div className="rlz-image-uploader__gallery">
                <h2>Gallery</h2>
                <div className="rlz-image-uploader__used-space">
                    <h4>Used space: {this.renderSize()}</h4>
                </div>
                <div className="rlz-image-uploader__uploaded-images">
                    <FastImagesPicker
                        images={images}
                        onDelete={this.onDelete}
                        onPick={this.onPick}
                        pickedKey={this.state.pickedImgKey}
                    />
                </div>
            </div>
        );
    };

    renderModal() {
        return (
            <rmd.Dialog
                modal
                open
                autoScrollBodyContent
                contentStyle={{
                    overflow: 'hidden',
                }}
                actions={[<rmd.FlatButton label="close" onClick={this.props.onClose} />]}
                onRequestClose={this.props.onClose}
            >
                {this.renderContent()}
            </rmd.Dialog>
        );
    }

    renderContent() {
        const { drawerOpen } = this.state;
        const { showGallery, galleryFirst, modal } = this.props;

        const wrapperClasses = cx('rlz-image-uploader', {});

        return (
            <div className={wrapperClasses}>
                {showGallery && galleryFirst && this.renderGallery()}
                {this.renderUploadBox()}
                {showGallery && !galleryFirst && this.renderGallery()}

                <rmd.Drawer
                    className="rlz-image-uploader__image-details-bar"
                    width={400}
                    openSecondary
                    open={this.state.drawerOpen}
                    disableSwipeToOpen
                >
                    <rmd.AppBar
                        onLeftIconButtonTouchTap={() => {
                            this.setState({ drawerOpen: false, pickedImgKey: null });
                        }}
                        iconElementLeft={
                            <rmd.IconButton>
                                <NavigationClose />
                            </rmd.IconButton>
                        }
                        style={{ zIndex: 100000, top: !modal && 64 }}
                        title={(this.state.userImages.find(i => i.key === this.state.pickedImgKey) || {}).name}
                    />
                    {this.renderImageDetails()}
                </rmd.Drawer>

                <rmd.Snackbar
                    open={this.state.copyToastOpen}
                    message="Copied to clipboard"
                    autoHideDuration={2000}
                    onActionTouchTap={() => this.setState({ copyToastOpen: false })}
                />

                <rmd.Snackbar
                    open={this.state.uploadOK}
                    message="IMAGE WAS UPLOADED"
                    autoHideDuration={4000}
                    bodyStyle={{}}
                    onRequestClose={() => this.setState({ uploadError: false, uploadOK: false })}
                />

                <rmd.Snackbar
                    open={this.state.uploadError}
                    message={this.state.uploadErrorMessage}
                    autoHideDuration={4000}
                    bodyStyle={{ backgroundColor: 'rgba(198,40,40,0.8)' }}
                    onRequestClose={() => this.setState({ uploadError: false, uploadErrorMessage: '' })}
                />
            </div>
        );
    }

    render() {
        const { drawerOpen } = this.state;
        const { galleryFirst, modal } = this.props;

        if (modal) return this.renderModal();
        return this.renderContent();
    }
}

export default ImageUploaderContainer;



/** WEBPACK FOOTER **
 ** ../src/dash/front/components/ImageUploaderContainer.js
 **/